module.exports = __webpack_public_path__ + "img/12-min.7b9a87c0.jpg";